<template>
    <div class="new-question-container">
		<div class="new-question-type-container" :style="`background-color:${$appColors.white}`">
			<new-answer-type />
		</div>
		<div class="new-question-type-config-container" :style="`background-color:${$appColors.white}`">
			<new-answer-type-config />
		</div>
		<div class="question-new-btns">
			<app-button
				text="Cancelar"
				:bg-color="$appColors.error"
				class="btn-tool"
				@click="goTo('answers')"
			/>
			<app-button
				:disabled="invalidAnswer"
				text="Guardar"
				class="btn-tool"
				@click="createAnswer"
			/>
		</div>
		<router-view name="modalAnswerIcon"></router-view>
    </div>
</template>
<script>
import newAnswerTypeConfig from '@/components/configuration/answer/new-answer-type-config';
import newAnswerType from '@/components/configuration/answer/new-answer-type';
import appButton from '@/components/shared/app-button';
import { mapGetters, mapState } from 'vuex';

function created() {
	const { id } = this.$route.params;
	if (id) {
		this.$store.dispatch('answer/loadEditingAnswerData', id);
	}
}

async function createAnswer() {
	const action = this.flagEdit ? 'editAnswer' : 'createAnswer';
	const msg = this.flagEdit ? 'actualizada' : 'creada';
	try {
		await this.$store.dispatch(`answer/${action}`);
		this.showNotification(
			`Respuesta ${msg} exitosamente`,
			'success',
		);
		this.goTo('answers');
	} catch (err) {
		this.showGenericError();
	}
}

function beforeDestroy() {
	this.$store.dispatch('answer/cleanBasicData');
}

export default {
	name: 'answer-new',
	beforeDestroy,
	components: {
		appButton,
		newAnswerType,
		newAnswerTypeConfig,
	},
	computed: {
		...mapGetters('answer', [
			'invalidAnswer',
		]),
		...mapState('answer', {
			flagEdit: state => !!state.editingAnswerId,
		}),
	},
	created,
	methods: {
		createAnswer,
	},
};
</script>
<style lang="scss" scoped>
.new-question-container {
	align-items: center;
	display: grid;
	height: calc(100vh - 180px);
	grid-column-gap: 30px;
	grid-template-columns: 1fr 1.5fr;

	.new-question-type-container,
	.new-question-type-config-container {
		height: inherit;
	}

	.question-new-btns {
		align-items: center;
		background-color: white;
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		padding: 20px;
		position: fixed;
		right: 0;

		.btn-tool {
			margin: 0 15px;
			padding: 5px 25px;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/answer/answer-new.vue